module.exports = __webpack_public_path__ + "img/53.7.Chla.ad9b581a.png";